<template>
  <div class="liquor-header-parent">
    <div class="liquor-header">
      <img class="logo" src="@/assets/logo（酒专栏）.png" @click="$router.push('/')" />
      <div class="menu">
        <el-menu mode="horizontal" :default-active="active" router>
          <el-menu-item index="/liquor/index">首页</el-menu-item>
          <el-menu-item index="/liquor/country">涨姿势</el-menu-item>
          <el-menu-item index="/liquor/browser">品美酒</el-menu-item>
          <el-menu-item index="/liquor/dana">做大拿</el-menu-item>
          <el-menu-item index="/liquor/life">造生活</el-menu-item>
        </el-menu>

        <!-- <HeaderMenu /> -->
      </div>
      <div>
        <SearchBar class="search" />
        <div class="vertical"></div>
        <el-dropdown class="bus" :tabindex="1234">
          <el-button>
            系统换乘
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu class="lquor-dropdown-menu" slot="dropdown">
            <el-dropdown-item>品类管理</el-dropdown-item>
            <el-dropdown-item>食安云网</el-dropdown-item>
            <el-dropdown-item>采购中台</el-dropdown-item>
            <el-dropdown-item>供零在线</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <MyHeader class="my" />
    </div>
  </div>
</template>

<script>
import HeaderMenu from "./HeaderMenu";
import SearchBar from "./SearchBar";
import MyHeader from "@/components/MyHeader";

export default {
  name: "Header",
  components: {
    HeaderMenu,
    SearchBar,
    MyHeader
  },
  props: {
    active: {
      type: String,
      default: ""
    }
  },
  methods: {}
};
</script>

<style lang="scss">
.lquor-dropdown-menu {
  background-color: #e4c896;
  border-color: #e4c896;
  .el-dropdown-menu__item {
    color: #3b2909;
  }

  .el-dropdown-menu__item:hover {
    color: #e4c896;
    background-color: #3b2909;
  }

  .popper__arrow {
    border-bottom-color: #e4c896;
  }

  .popper__arrow::after {
    border-bottom-color: #e4c896;
  }
}

.liquor-header-parent {
  width: 100vw;
  height: 70px;

  position: fixed;
  top: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 1);
}

.liquor-header {
  width: 100vw;
  margin: 0 auto;

  display: flex;

  justify-content: space-around;

  .logo {
    margin-left: 10%;
    height: 36px;
    margin: 17px 0;
    cursor: pointer;
  }

  .menu {
    width: 300px;
    display: inline-block;
    vertical-align: top;
    z-index: 9999;
    // margin-left: 100px;

    .el-menu {
      background: rgba(0, 0, 0, 0);
    }

    .el-menu.el-menu--horizontal {
      border: 0;
    }

    .el-menu--horizontal > .el-menu-item {
      font-size: 14px;
      font-weight: 400;
      color: rgba(228, 200, 150, 1);
      padding: 0 10px;
      height: 70px;
      line-height: 70px;
      opacity: 0.7;
    }

    .el-menu-item:hover {
      opacity: 1;
      font-weight: 600;
      background: rgba(0, 0, 0, 0);
    }

    .el-menu--horizontal > .el-menu-item.is-active {
      border: 0;
      opacity: 1;
    }

    .el-menu--horizontal > .el-menu-item.is-active::after {
      content: "";
      height: 1px;
      background-color: #e4c896;
      width: 60%;
      position: absolute;
      top: 50px;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .search {
    width: 180px;
    display: inline-block;
    vertical-align: top;
    margin: 18px 0;
    // margin-left: 100px;
  }

  .vertical {
    display: inline-block;
    width: 1px;
    height: 14px;
    margin: 28px 0;
    margin-left: 20px;
    background: rgba(255, 255, 255, 0.4);
    // opacity: 0.4;
  }

  .bus {
    display: inline-block;
    vertical-align: top;
    margin-top: 15px;
    // margin-left: 100px;

    .el-dropdown-selfdefine {
      // border: 1px solid #e4c896;
      border: none;
      background: rgba(0, 0, 0, 0);

      color: #e4c896;
    }
  }

  .my {
    // float: right;
    width: 90px;
    vertical-align: top;

    .el-dropdown-selfdefine {
      color: #e4c896;
    }
  }
}
</style>

